import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["form", "checkbox"];

  declare formTargets: HTMLFormElement[];
  declare checkboxTargets: [HTMLInputElement];

  connect(): void {
    // These are plain full-page form submits (button_to → POST → redirect →
    // reload), not AJAX — there's a real network round trip before any
    // feedback (the "Triggered standardisation for N candidate(s)" flash)
    // appears, and nothing stops a second click in that window, risking
    // triggering the same bulk action (e.g. Standardise CV) more than once
    // for the same selection. Disable the button the moment its form is
    // submitted so a click can't land twice while the page is loading.
    this.formTargets.forEach((form) => {
      form.addEventListener("submit", () => this.#disableSubmitButtons(form));
    });
  }

  setFormsParams(): void {
    this.formTargets.forEach((form) => {
      let candidateIdsInput = form.querySelector(
        "[name='job_opening_candidate_ids']"
      ) as HTMLInputElement;
      if (!candidateIdsInput) {
        candidateIdsInput = document.createElement("input");
        candidateIdsInput.type = "hidden";
        candidateIdsInput.name = "job_opening_candidate_ids";
        form.appendChild(candidateIdsInput);
      }
      candidateIdsInput.value = this.#selectIds().join(",");
    });
  }

  #selectIds(): string[] {
    return this.checkboxTargets
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) => checkbox.value);
  }

  #disableSubmitButtons(form: HTMLFormElement): void {
    form.querySelectorAll("button").forEach((button) => {
      (button as HTMLButtonElement).disabled = true;
      button.classList.add("opacity-50", "cursor-not-allowed");
    });
  }
}
